"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var yup_1 = require("yup");
yup_1.addMethod(yup_1.object, 'minProperties', function (minProperties) {
    return this.test('min-properties', "Object in path: ${path} does not satisfy minimum number of properties: " + minProperties, function (schema) {
        var properties = schema ? Object.keys(schema).length : 0;
        return properties >= minProperties;
    });
});
yup_1.addMethod(yup_1.object, 'maxProperties', function (maxProperties) {
    return this.test('max-properties', "Object in path: ${path} does not satisfy maximum number of properties: " + maxProperties, function (schema) {
        var properties = schema ? Object.keys(schema).length : 0;
        return properties <= maxProperties;
    });
});
//# sourceMappingURL=yupEnrcihment.js.map